import { fetcher } from '@commenda/utils';

import { IExternalShare } from './types';

export const revokeFileShare = async (
  id: string
): Promise<{ share: IExternalShare }> => {
  const res = await fetcher(`file-shares/${id}/revoke`, { method: 'POST' });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Failed to revoke share link.');
  }
  return await res.json();
};
